import axios from 'axios';

export async function getBackgroundImage() {
  const response = await axios.get('/api/backgroundImage');
  return response.data;
}